import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { LoadingService } from '@schoolbelle/common/loading';
import { identity, mapValues, pickBy } from 'lodash';
import { switchMap } from 'rxjs/operators';
import { IssueTrackerService } from '../../../shared/services/issue-tracker/issue-tracker.service';
import { environment } from '../../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-issue-tracking',
  templateUrl: './issue-tracking.component.html',
  styleUrls: ['./issue-tracking.component.scss'],
})
export class IssueTrackingComponent implements OnInit {
  constructor(
    private loading: LoadingService,
    private issueTracker: IssueTrackerService,
  ) {}

  ngOnInit() {}

  getList() {}

  go() {
    const subscription = this.issueTracker.getToken().subscribe((token) => {
      const confirmed = confirm('이슈트래커 페이지를 여시겠습니까?');
      const url = 'https://sbe-issue-tracking.web.app/buckets/1nzXvLeNAGiJSsDhPBMN/issues';
      // const url = " http://localhost:4200/buckets/1nzXvLeNAGiJSsDhPBMN/issues";
      const params = new HttpParams({ fromObject: mapValues(pickBy({ token }, identity), (v) => '' + v) }).toString();
      if (confirmed) window.open(`${url}?${params}`, '_blank');
    });
    this.loading.open({ busy: subscription });
  }
}
